export default "__VITE_ASSET__C9HZ7S99__"